import { render, staticRenderFns } from "./pensionStat.vue?vue&type=template&id=9005af92&scoped=true&"
import script from "./pensionStat.vue?vue&type=script&lang=js&"
export * from "./pensionStat.vue?vue&type=script&lang=js&"
import style0 from "./pensionStat.vue?vue&type=style&index=0&id=9005af92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9005af92",
  null
  
)

export default component.exports